import apiClient from './api';
import { Project, ProjectCreate, ProjectUpdate } from '../types/api.types';

/**
 * Project service for interacting with the project endpoints
 */
export class ProjectService {
  private baseUrl = '/ctem/ui/projects';

  /**
   * Get all projects
   */
  async getProjects(): Promise<Project[]> {
    console.log('ProjectService: Fetching projects from:', `${this.baseUrl}/`);
    // Use a high limit to fetch all projects and sort by newest first
    const projects = await apiClient.get<Project[]>(`${this.baseUrl}/?limit=1000&skip=0`);
    console.log('ProjectService: Received projects:', projects);
    
    // Sort by creation date (newest first) on the frontend as backup
    const sortedProjects = projects.sort((a, b) => 
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    );
    
    return sortedProjects;
  }

  /**
   * Get a project by ID
   */
  async getProject(id: string): Promise<Project> {
    return apiClient.get<Project>(`${this.baseUrl}/${id}`);
  }

  /**
   * Create a new project
   */


  private validateBurpHost(host: string): boolean {
    // Allow localhost, IP addresses, and domain names, with optional port
    const hostPattern = /^(localhost|(\d{1,3}\.){3}\d{1,3}|[a-zA-Z0-9.-]+)(:\d{1,5})?$/;
    return hostPattern.test(host);
  }

  async createProject(project: ProjectCreate): Promise<Project> {
    console.log('ProjectService: Creating project:', project);
    if (project.burp_host && !this.validateBurpHost(project.burp_host)) {
      throw new Error('Invalid Burp Suite host/IP format. Expected format: hostname:port or IP:port');
    }
    const createdProject = await apiClient.post<Project>(`${this.baseUrl}/`, project);
    console.log('ProjectService: Created project response:', createdProject);
    return createdProject;
  }

  /**
   * Update an existing project
   */
  async updateProject(id: string, project: ProjectUpdate): Promise<Project> {
    if (project.burp_host && !this.validateBurpHost(project.burp_host)) {
      throw new Error('Invalid Burp Suite host/IP format. Expected format: hostname:port or IP:port');
    }
    return apiClient.put<Project>(`${this.baseUrl}/${id}`, project);
  }

  /**
   * Delete a project
   */
  async deleteProject(id: string): Promise<void> {
    return apiClient.delete<void>(`${this.baseUrl}/${id}`);
  }
}

// Export singleton instance
export const projectService = new ProjectService();
export default projectService;
